import { yupResolver } from "@hookform/resolvers/yup";
import { If } from "components";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from "react";
import { Resolver, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Button, FormField, Input, RadioButton } from "ui";

import { VerificationDecision, RejectionReasons } from "../../../constants";
import { resellerValidationSchema } from "../../../helpers";
import {
  ResellerVerificationFormProps,
  ResellerVerificationFormValues
} from "./ResellerVerificationForm.types";

import styles from "./ResellerVerificationForm.module.scss";

const ResellerVerificationForm = ({
  resellerId,
  onSubmit
}: ResellerVerificationFormProps) => {
  const { t } = useTranslation();
  const { register, handleSubmit, watch, formState, clearErrors } =
    useForm<ResellerVerificationFormValues>({
      defaultValues: {
        resellerId
      },
      resolver: yupResolver(resellerValidationSchema) as Resolver<any, any>
    });

  const decisionWatch = watch("decision");
  const rejectionReasonWatch = watch("rejectionReason");

  const errors = formState.errors;

  useEffect(() => {
    if (rejectionReasonWatch) {
      clearErrors();
    }
  }, [rejectionReasonWatch, clearErrors]);

  return (
    <form className={styles.verificationForm} onSubmit={handleSubmit(onSubmit)}>
      <FormField errorMessage={Object.values(errors)[0]?.message}>
        <div className={styles.verificationForm_fieldsContainer}>
          <RadioButton
            label={t("Approve reseller")}
            className={styles.verificationForm_mainField}
            value={VerificationDecision.Approve}
            data-testid="resellerVerification--approve"
            {...register("decision")}
          />
          <RadioButton
            label={t("Reject reseller")}
            className={styles.verificationForm_mainField}
            value={VerificationDecision.Decline}
            data-testid="resellerVerification--reject"
            {...register("decision")}
          />

          <If condition={decisionWatch === VerificationDecision.Decline}>
            <div className={styles.verificationForm_rejectReasonBlock}>
              <h3 className={styles.verificationForm_rejectReasonBlock_title}>
                {t("Reason of rejection")}:
              </h3>

              {Object.values(RejectionReasons).map((reason) => (
                <RadioButton
                  key={reason}
                  label={reason}
                  className={styles.verificationForm_rejectionReasonField}
                  value={reason}
                  {...register("rejectionReason")}
                />
              ))}

              <If condition={rejectionReasonWatch === RejectionReasons.Other}>
                <Input
                  asTag="textarea"
                  {...register("otherRejectionReason")}
                  placeholder="Message"
                />
              </If>
            </div>
          </If>
        </div>
      </FormField>

      <Button
        type="submit"
        title={t("Save")}
        className={styles.verificationForm_submitBtn}
      />
    </form>
  );
};

export default ResellerVerificationForm;
